var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 6.625V50.375C0.375 53.8125 3.15625 56.625 6.625 56.625H50.375C53.8125 56.625 56.625 53.8125 56.625 50.375V6.625C56.625 3.1875 53.8125 0.375 50.375 0.375H6.625C3.15625 0.375 0.375 3.1875 0.375 6.625ZM37.875 19.125C37.875 24.3125 33.6875 28.5 28.5 28.5C23.3125 28.5 19.125 24.3125 19.125 19.125C19.125 13.9375 23.3125 9.75 28.5 9.75C33.6875 9.75 37.875 13.9375 37.875 19.125ZM9.75 44.125C9.75 37.875 22.25 34.4375 28.5 34.4375C34.75 34.4375 47.25 37.875 47.25 44.125V47.25H9.75V44.125Z",
    fill: "#E6E7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.ffeb28dba09ef6c64d2996e6f48e21f8.svg";
export { ForwardRef as ReactComponent };